export default __webpack_public_path__ + "static/media/consBg.92d0cf9a.jpg";